$(document).ready(function() {

    $(window).on('scroll load',  () => {
        if(window.scrollY > 0) {
           $('.header-navigation').addClass('scrolling');
      	   $('#shopify-section-features').addClass('fixed');
      
      		var height = $('.header-navigation').outerHeight();
      
      		$('#shopify-section-features').css('top', height - 2);
        } else {
           $('.header-navigation').removeClass('scrolling');
           $('#shopify-section-features').removeClass('fixed');
        }
    });

    $('#sortBy').on('change', function () {
        let location = document.location;
        let sortValue = $('#sortBy').val();
        location.href = location.origin + location.pathname + '?sort_by=' + sortValue;
    });

    $('.btn-counter').on('click', function() {
        let oldValue = $(this).parent().find('input').val();
        let newVal = '';

        if ($(this).data('counter') === '+') {
            newVal = parseFloat(oldValue) + 1;
        } else {
            if (oldValue > 0) {
                newVal = parseFloat(oldValue) - 1;
            } else {
                newVal = 0;
            }
        }

        $(this).parent().find('input').val(newVal);

    });

  if($('#shopify-section-announcement-bar').length > 0) {
    var height = $('#shopify-section-announcement-bar').outerHeight();
    
    console.log(height);
    
	$('#header .header-navigation').css('top', height);
  };
});